import { Translate } from 'react-redux-i18n'

export const TranslateDelateItems = ({ count }) => (
  <Translate
    value={`cartAndOrders.main.${
      count < 2 ? 'confirmDeleteItem' : 'confirmDeleteItems'
    }`}
    count={count}
  />
)
